var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rm-layout"},[_c('Navbar',{attrs:{"unread-count":_vm.unreadCount}}),_c('div',{staticClass:"rm-layout__page"},[_c('AppMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }